<template>
    <div> 
        <b-navbar class="navbar" toggleable="lg" type="dark" variant="secondary">
            <b-navbar-brand to="/motorista" v-if="level==='motorista'">RouteSys</b-navbar-brand>
            <b-navbar-brand to="/" v-if="level!=='motorista'">RouteSys</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav v-if="level!=='motorista'">
                    <b-nav-item to="/clientes" v-if="level!=='cliente'">Clientes</b-nav-item>
                    <b-nav-item to="/funcionarios" v-if="level!=='cliente'">Funcionarios</b-nav-item>
                    <b-nav-item to="/planos" v-if="level==='admin'">Planos</b-nav-item>
                    <b-nav-item to="/status" v-if="level!=='cliente'">Status</b-nav-item>
                    <b-nav-item to="/paradas" v-if="level!=='cliente'">Paradas</b-nav-item>
                    <b-nav-item to="/transportes" v-if="level!=='cliente'">Transportes</b-nav-item>
                    <b-nav-item to="/statusRastreio" v-if="level!=='cliente'">Atualizar Status</b-nav-item>
                    <b-nav-item to="/rastreio">Rastreio</b-nav-item>
                    <b-nav-item-dropdown text="Relatórios" v-if="level!=='cliente'">
                        <b-dropdown-item to="/report_clientes">Clientes</b-dropdown-item>
                        <b-dropdown-item to="/report_funcionarios">Funcionários</b-dropdown-item>
                        <b-dropdown-item to="/report_motoristas">Motoristas</b-dropdown-item>
                        <b-dropdown-item to="/report_logTransportes">Registro de Transportes</b-dropdown-item>
                        <b-dropdown-item to="/report_clienteTransportes">Transportes por Cliente</b-dropdown-item>
                        <b-dropdown-item to="/report_clientePeriodoTransportes">Transportes por Cliente e Período</b-dropdown-item>
                        <b-dropdown-item to="/report_motoristaTransportes">Transportes por Motorista</b-dropdown-item>
                        <b-dropdown-item to="/report_motoristaPeriodoTransportes">Transportes por Motorista e Período</b-dropdown-item>
                        <b-dropdown-item to="/report_statusTransportes">Transportes por Status</b-dropdown-item>
                        <b-dropdown-item to="/report_statusPeriodoTransportes">Transportes por Status e Período</b-dropdown-item>
                        <b-dropdown-item to="/report_lateTransportes">Transportes Atrasados</b-dropdown-item>
                        <b-dropdown-item to="/repDisponibilidade">Disponibilidade</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                    <b-nav-item-dropdown :text="usuario" right>
                        <b-dropdown-item to="/mapa" v-if="level==='admin'">Localização de Motoristas</b-dropdown-item>
                        <b-dropdown-item to="/configs" v-if="level==='admin'">Configuração</b-dropdown-item>
                        <b-dropdown-item to="/empresas" v-if="level==='admin'">Empresa</b-dropdown-item>
                        <b-dropdown-item to="/notificacoes" v-if="level==='admin'">Notificações</b-dropdown-item>
                        <b-dropdown-divider v-if="level==='admin'"/>
                        <b-dropdown-item to="/me">Meus Dados</b-dropdown-item>
                        <b-dropdown-divider/>
                        <b-dropdown-item to="/senha">Alterar Senha</b-dropdown-item>
                        <b-dropdown-divider/>
                        <b-dropdown-item href @click.prevent="logout">Logout</b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: "Menu",
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            usuario: '',
            level: ''
        }
    },
    methods: {
        logout () {
            const local = localStorage.getItem('__SYSTEM_USER')
            const jwt = JSON.parse(local)
            axios(`${baseApiUrl}/backend/logout.php?jwt=${jwt}`)
            .then(() => {
                this.$toasted.global.defaultSuccess({ message : 'Logout Realizado com sucesso!' })
                localStorage.removeItem('__SYSTEM_USER')
                this.$router.push({ name: 'login' })
                this.$store.commit('toggleVisible', false)
            })
            .catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })

        }
    },
    mounted() {
        const local = localStorage.getItem('__SYSTEM_USER')
        const decodedToken = this.jwt.decodeToken(local)
        if (local === null) {
            this.$router.push({ path: '/login' })
            this.$store.commit('toggleVisible', false)
        } else {
            this.level = decodedToken['data'].level
            this.usuario = decodedToken['data'].nome
            this.$store.commit('toggleVisible', true)
        }
    }
}
</script>

<style>
.navbar {
    z-index: 9;
}
</style>